import { api } from './api';

export interface HabboUser {
  name: string;
  uniqueId: string;
  motto: string;
  memberSince: string;
  profileVisible: boolean;
}

export interface HabboCheckResponse {
  exists: boolean;
  user?: HabboUser;
  message?: string;
}

export const habboService = {
  async checkUserExists(username: string): Promise<HabboCheckResponse> {
    try {
      const response = await api.get<HabboCheckResponse>('/habbo/check-user', {
        params: { username }
      });
      return response.data;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return {
          exists: false,
          message: 'Usuário não encontrado no Habbo'
        };
      }
      throw error;
    }
  }
};
